import React, {useState} from "react";
import {Flex, Form, Input, Space} from "antd";
import './../../styles/noweZgloszenie.css';
import Header from "./Header";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import NoweZgloszenieLayaut from "./NoweZgloszenieLayaut";
const { TextArea } = Input;

const NoweZgloszenieMain = () => {
    const [anonimowe, setAnonimowe] = useState(true);

    return (<NoweZgloszenieLayaut>
            <Flex gap="middle" align="center" vertical style={{padding: '5px'}}>
                <div style={{padding: '150px 15px'}}>
                    <h1 style={{marginBottom: 0}}>Byłeś świadkiem naruszenia prawa?</h1>
                    <p style={{margin: '0 0 15px 0'}}>Zgłoszenie naruszenia prawa ma pozwolić na podjęcie działań przed wystąpieniem skutków takiego naruszenia lub je maksymalnie zminimalizować.</p>
                    <Button href={'/noweZgloszenie'} size={'lg'}>Zgłoś naruszenie prawa</Button>
                </div>

            </Flex>
    </NoweZgloszenieLayaut>
    )
}

export default NoweZgloszenieMain;
